import { NumberFormatter, Table } from "@mantine/core";

export default function CreditsTable({ credits, formatCreditType }) {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Type</Table.Th>
          <Table.Th ta="right">Credits</Table.Th>
          <Table.Th ta="right">Original</Table.Th>
          <Table.Th>Valid</Table.Th>
          <Table.Th ta="right">Lock</Table.Th>
          <Table.Th>Created</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {credits?.map((p) => (
          <Table.Tr key={p.id}>
            <Table.Td>
              {formatCreditType
                ? formatCreditType(p.creditType || "default")
                : p.creditType || "default"}
            </Table.Td>
            <Table.Td ta="right">
              <NumberFormatter thousandSeparator value={p.creditsTotal} />
            </Table.Td>
            <Table.Td ta="right">
              <NumberFormatter thousandSeparator value={p.originalAmount} />
            </Table.Td>
            <Table.Td>{p.validUntil}</Table.Td>
            <Table.Td ta="right">{p.lock}</Table.Td>
            <Table.Td>{p.idCreated}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
